import { BannerItem, BannersResponse } from "../components/feedback/AdsCarousel/types/adBanners.types";

export function mapBannersResponseToItems(response?: BannersResponse): BannerItem[] {
    if (!response || !response.bannerCollection || !response.bannerCollection.items) {
        return [];
    }
    return response.bannerCollection.items.flatMap((collection) => {
        return collection.itemsCollection?.items || [];
    });
}